import * as XLSX from "xlsx";

export class ExcelWorkBookBuilder {
    private workSheets: XLSX.WorkSheet[] = [];
    private workSheetNames: string[] = []

    public addWorkSheet(workSheet: XLSX.WorkSheet, workSheetName: string) {
        this.workSheets.push(workSheet);
        this.workSheetNames.push(workSheetName)
    }

    public addWorkSheets(workSheets: XLSX.WorkSheet[], workSheetNames: string[]) {
        for (let index = 0; index < workSheets.length; index++) {
            const workSheet = workSheets[index];
            const name = workSheetNames[index];

            this.workSheets.push(workSheet);
            this.workSheetNames.push(name);
        }
    }

    public build(): XLSX.WorkBook {
        let sheets: { [sheet: string]: XLSX.WorkSheet } = {};

        for (let index = 0; index < this.workSheets.length; index++) {
            const workSheet = this.workSheets[index];
            const workSheetName = this.workSheetNames[index];
            sheets[workSheetName] = workSheet;
        }

        const workbook: XLSX.WorkBook = { Sheets: sheets, SheetNames: this.workSheetNames };
        return workbook;
    }

}
